import { InfoNotice, type InfoNoticeProps } from '@/components/patterns/info-notice'
import { Tags } from 'lucide-react'

export function PriceChangeAlert({
  title = null,
  children,
  body = null,
  action = null,
  icon = <Tags />,
  tone = 'pricing',
  compact = false,
  className = '',
  onDismiss = null,
  dismissLabel = 'Dismiss price change notice',
}: InfoNoticeProps) {
  return (
    <InfoNotice
      title={title}
      body={body}
      action={action}
      tone={tone}
      compact={compact}
      className={className}
      icon={icon}
      onDismiss={onDismiss}
      dismissLabel={dismissLabel}
    >
      {children}
    </InfoNotice>
  )
}
